module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M4 31v-9h26c1.106 0 2-.894 2-2V4c0-1.106-.894-2-2-2H4c0-1.106-.894-2-2-2S0 .894 0 2v29a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/flag-2.js
// module id = 1148
// module chunks = 14